import '../pages.css';
import { Link } from 'react-router-dom';

const PMMA = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>PMMA Provisional</h1>
                    <p className="product-tagline">Reliable temporary restorations with pleasing esthetics</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            PMMA provisional restorations from <strong>AbELab</strong> are milled from dense PMMA blocks, offering reliable
                            strength and pleasing translucency for temporary restorative needs.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Temporary crowns and bridges</li>
                                <li>Short- to medium-term provisionalization</li>
                            </ul>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>High esthetic-demand definitive cases</li>
                                <li>Situations requiring strong adhesive bonding</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation, Cementation & Technical Notes</h2>
                        <p>Preparation and cementation guidelines mirror those of full-contour zirconia restorations.</p>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2740</strong> – Crown, porcelain/ceramic substrate</li>
                            <li><strong>D6245</strong> – Pontic, porcelain/ceramic</li>
                            <li><strong>D6740</strong> – Abutment crown, porcelain/ceramic</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PMMA;
